var account = "账户";
var accountSettings = "账户设置";
var charging = "充电";
var contactInfo = "联系信息";
var dashboard = "主页";
var home = "主页";
var myProducts = "我的产品";
var orderHistory = "订单历史记录";
var paymentMethod = "付款方式";
var profileSettings = "个人设置";
var referAndEarn = "引荐奖励";
var signOut = "退出登录";
var zh_CN = {
	account: account,
	accountSettings: accountSettings,
	charging: charging,
	contactInfo: contactInfo,
	dashboard: dashboard,
	home: home,
	myProducts: myProducts,
	orderHistory: orderHistory,
	paymentMethod: paymentMethod,
	profileSettings: profileSettings,
	referAndEarn: referAndEarn,
	signOut: signOut
};

export { account, accountSettings, charging, contactInfo, dashboard, zh_CN as default, home, myProducts, orderHistory, paymentMethod, profileSettings, referAndEarn, signOut };
